import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BasicStateReelSymbol} from "../game/symbols/BasicStateReelSymbol";
import {ITractorBeamBetLineInitialData} from "../game/winpresentation/TractorBeamInitialWinPresentationController";
import {TractorBeamStateMatrix} from "./TractorBeamStateMatrix";

export class TractorBeamHelper {

    public static shuffle(array:any[]):any[] {
        let tmp:number;
        let current:number;
        let top:number = array.length;
        if(top) while(--top) {
            current = Math.floor(Math.random() * (top + 1));
            tmp = array[current];
            array[current] = array[top];
            array[top] = tmp;
        }
        return array;
    }

    public static createSymbolStateMatrixFromBetWinsWithWeights(betWinsData:IBetLineWinData[]):TractorBeamStateMatrix<number> {
        let states:TractorBeamStateMatrix<number> = new TractorBeamStateMatrix<number>(5, 3, [0, 2], 0);

        for(let i:number = 0; i < betWinsData.length; i++) {
            let betLineWinData:ITractorBeamBetLineInitialData = <ITractorBeamBetLineInitialData>betWinsData[i];
            let symbolsNum:number = betLineWinData.betLineIndex >= 0 ? betLineWinData.nrOfSymbols : (betLineWinData.betLine.length);
            let betLinesPerWinDirection:number = betLineWinData.lineStart === "Right" ? 4 : 0;
            for(let j:number = 0; j < symbolsNum; j++) {
                let reelIndex = Math.abs(betLinesPerWinDirection - j);
                if(betLineWinData.betLine[reelIndex] >= 0) {
                    states.setStateAt(reelIndex, betLineWinData.betLine[reelIndex], 1);
                }
            }
        }
        return states;
    }

    public static createSymbolStateMatrixFromScatterWins(scatterWinPositions:number[]):TractorBeamStateMatrix<number> {
        let states:TractorBeamStateMatrix<number> = new TractorBeamStateMatrix<number>(5, 3, [0, 2], 0);

        for(let i:number = 0; i < scatterWinPositions.length; i++) {
            let betLineWinData:any = scatterWinPositions[i];
            for(let j:number = 0; j < betLineWinData.length; j++) {
                if(betLineWinData[j]) {
                    states.setStateAt(i, j, 1);
                }
            }
        }
        return states;
    }

    public static getSymbolsWithState(symbolStates:TractorBeamStateMatrix<any>, state:any):{} {
        let symbols:any = [];
        const coordinates:[number, number][] = symbolStates.getAllCoordinatesWithState(state);
        for(let i:number = 0; i < coordinates.length; i++) {
            const reelIndex:number = coordinates[i][0];
            const symbolIndex:number = coordinates[i][1];
            const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol>Reels.getSymbol(reelIndex, symbolIndex);
            if(symbol != null) {
                symbols.push({"reelIndex" : reelIndex, "symbolIndex" : symbolIndex, "symbol" : symbol});
            }
        }
        return symbols;
    }

    public static differenceBetweenArrays(array1:any[], array2:any[]):any[] {
        let result:any[] = [];
        for(var i = 0; i < array1.length; i++) {
            if(array2.indexOf(array1[i]) === -1) {
                result.push(array1[i]);
            }
        }
        return result;
    }

    public static radians(degrees:number):number {
        return degrees * Math.PI / 180;
    }
}
